import { render, staticRenderFns } from "./Memed.vue?vue&type=template&id=2a721cda&scoped=true&"
import script from "./Memed.vue?vue&type=script&lang=js&"
export * from "./Memed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a721cda",
  null
  
)

export default component.exports